import { Cookies } from 'react-cookie';
import { COOKIES } from '../constants/misc.js';

const cookies = new Cookies();
function getAuthIdParam(companyId) {
    return companyId ? `a_i=${companyId}` : `a_i=${cookies.get(COOKIES.companyId)}`;
}

export { getAuthIdParam };
//# sourceMappingURL=getAuthIdParam.js.map
